import { render, staticRenderFns } from "./EventCardMobile.vue?vue&type=template&id=10166cb2"
import script from "./EventCardMobile.vue?vue&type=script&lang=js"
export * from "./EventCardMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports